import request from '@/utils/http.js';

// 发起端-开始增加虚拟观众
const virtualClientStart = (params = {}) => {

  return request({
    url: '/v3/webinars/virtual/start',
    method: 'GET',
    params: params
  });
};

// 发起端-增加虚拟观众
const virtualAccumulation = (params = {}) => {

  return request({
    url: '/v3/webinars/virtual/accumulation',
    method: 'GET',
    params: params
  });
};

// 发起端-获取虚拟观众基数
const virtualClientGet = (params = {}) => {

  return request({
    url: '/v3/webinars/virtual/get-base',
    method: 'GET',
    params: params
  });
};
const getVirtualLikes = (params = {}) => {

  return request({
    url: '/v3/interacts/like/get-room-like',
    method: 'GET',
    params: params
  });
};
const getVirtualLikesSet = (params = {}) => {

  return request({
    url: '/v3/interacts/like/get-config',
    method: 'GET',
    params: params
  });
};
const setVirtualLikes = (params = {}) => {
  return request({
    url: '/v3/interacts/like/set-config',
    method: 'POST',
    data: params
  });
}
const virtualClient = {
  virtualClientStart,
  virtualAccumulation,
  virtualClientGet,
  getVirtualLikesSet,
  getVirtualLikes,
  setVirtualLikes
};

export default virtualClient;
